import "./AppVersionDetail.scss"
import {RaikoIcon} from "../../raikoComponents/raikoIcon/RaikoIcon";
import {RaikoIconTypes} from "../../raikoComponents/raikoIcon/RaikoIconTypes";
import {css} from "@emotion/css";
import RaikoInput from "../../raikoComponents/raikoInputs/RaikoInput";
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";
import React, {useState} from "react";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoGridThreeColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridThreeColumn";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import RaikoNumberInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoNumberInputOutlined";
import RaikoSimpleMultiLineInputOutlined
    from "../../raikoComponents/raikoCustomInput/RaikoSimpleMultiLineInputOutlined";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";
import RaikoToggleOutlined from "../../raikoComponents/raikoCustomInput/raikoToggleOutlined/RaikoToggleOutlined";
import Divider from "@mui/material/Divider";
import {RaikoDivider} from "../../raikoComponents/raikoDivider/RaikoDivider";

export const AppVersionDetail = ({appVersionId = -1}) => {

    const [apkId, setApkId] = useState(-1);
    const [apkFile, setApkFile] = useState(null);
    const [apkFileName, setApkFileName] = useState("");
    const apkFileSelectHint = "لطفا فایل APK مورد نظر خود را انتخاب نمایید. 😇"

    const [appTitle, setAppTitle] = useState("");
    const [appVersionCode, setAppVersionCode] = useState("");
    const [appMinimumVersionCode, setAppMinimumVersionCode] = useState("");
    const [appDescription, setAppDescription] = useState("");
    const [appEnabled, setAppEnabled] = useState(false);
    const [appMandatory, setAppMandatory] = useState(false);

    function uploadApkFile({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            setApkId(-1)
            setApkFile(files[0])
            setApkFileName(files[0].name)
        }
    }

    return (
        <section className={"appVersionDetailContainer"}>

            <div className={"appVersionApkSelectContainer"}>
                <div className={"appVersionIconContainer"}>
                    <RaikoIcon icon={apkFileName ? RaikoIconTypes.icAndroidOs : RaikoIconTypes.icAndroidOsGray}
                               className={`appVersionIcon`}/>
                </div>
                <RaikoLabel text={apkFileName.length > 0 ? apkFileName : apkFileSelectHint}
                            className={"appVersionTitle"}
                />

                <ButtonPrimaryRaiko label={"انتخاب نسخه"}
                                    onClick={_ => document.getElementById("androidFile").click()}
                />

                <input
                    id='androidFile'
                    type="file"
                    hidden
                    accept="application/vnd.android.package-archive"
                    onChange={uploadApkFile}/>

            </div>

            <RaikoGridThreeColumn>

                <RaikoMaterialOutlinedInput
                    labelText={"نام نسخه"}
                    value={appTitle}
                    setValue={setAppTitle}
                />
                <RaikoNumberInputOutlined
                    labelText={"شماره نسخه"}
                    value={appVersionCode}
                    setValue={setAppVersionCode}
                />
                <RaikoNumberInputOutlined
                    labelText={"حداقل نسخه مجاز"}
                    value={appMinimumVersionCode}
                    setValue={setAppMinimumVersionCode}
                />
            </RaikoGridThreeColumn>

            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات"}
                setValue={setAppDescription}
                value={appDescription}
            />

            <RaikoGridTwoColumn>
                <RaikoToggleOutlined
                    labelText={"وضعیت (فعال/غیرفعال)"}
                    setChecked={setAppEnabled}
                    checked={appEnabled}
                />

                <RaikoToggleOutlined
                    labelText={"بروزرسانی (اجباری/اختیاری)"}
                    setChecked={setAppMandatory}
                    checked={appMandatory}
                />
            </RaikoGridTwoColumn>

            <div className={"appVersionButtonContainer"}>
                <ButtonPrimaryRaiko label={"افزودن"}/>
            </div>

        </section>
    )
}